module.exports = __webpack_public_path__ + "static/media/logo_transparent.5aeac3ea.png";